import React, { useMemo } from 'react';

import { LibraryFilterItem } from '../../../shared/FinancialDataContext/FinancialDataContext.types';
import FilterLibraryItem from './FilterLibraryItem';

interface Props {
  items: LibraryFilterItem[];
  filterItem: LibraryFilterItem;
  path: number[];
}

const FilterLibraryGroup: React.FC<Props> = React.memo(({ items, filterItem, path }) => {
  const renderedGroup = useMemo(() => {
    return items.map((filterItem, index: number) => (
      <FilterLibraryItem
        key={`index-${[...path, index].join('-')}-${filterItem.labelKey}`}
        path={[...path, index]}
        filterItem={filterItem}
      />
    ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterItem]);

  return <>{renderedGroup}</>;
});

export default FilterLibraryGroup;
